export default __webpack_public_path__ + "static/media/fast-icon.4d731cd3.svg";